import { render, staticRenderFns } from "./PopupContent.vue?vue&type=template&id=a5e97ede&scoped=true"
import script from "./PopupContent.vue?vue&type=script&lang=js"
export * from "./PopupContent.vue?vue&type=script&lang=js"
import style0 from "./PopupContent.vue?vue&type=style&index=0&id=a5e97ede&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5e97ede",
  null
  
)

export default component.exports